import { IconTypes } from "../components/ui/icons";
import { Activity } from "../models/activity";
import TrainingModule from "../models/trainingModule";

export enum EventType {
  ScheduleSurveyLaunch = "SCHEDULE_SURVEY_LAUNCH",
  SurveyLaunch = "SURVEY_LAUNCH",
  SurveyReminder = "SURVEY_REMINDER",
  SurveyDueDate = "SURVEY_DUE_DATE",
  Touchpoint = "TOUCHPOINT",
}

export enum ActivityType {
  ScheduleSurvey = "SCHEDULE_SURVEY",
  Survey = "SURVEY",
  Training = "TRAINING",
  LeadershipTraining = "LEADERSHIP_TRAINING",
}

export interface TouchpointProperties {
  id?: string;
  description?: string;
  order?: number;
}

export interface TrainingModuleProperties {
  id?: string;
  description?: string;
}

export interface ActivityExtraProperties {
  training_module?: TrainingModuleProperties;
  dispatch?: {
    id?: string;
  };
  [key: string]: any;
}

export interface EventExtraProperties {
  touchpoint?: TouchpointProperties;
  [key: string]: any;
}

export interface EventResponse {
  id: number | undefined;
  activity_id: number | undefined;
  event_type: EventType;
  date: string;
  label: string;
  extra_properties: EventExtraProperties;
}

export interface ActivityResponse {
  id: number | undefined;
  activity_type: ActivityType;
  label: string;
  start_date: string;
  end_date: string | undefined;
  events: EventResponse[];
  extra_properties: ActivityExtraProperties;
}

export interface todoLink {
  [key: string]: string;
}

export interface SwimlaneData {
  title: string;
  icon: IconTypes;
  activities: Activity[];
}

export interface SwimlanesData {
  inclusionPulse: SwimlaneData;
  microLearning: SwimlaneData;
  leadershipLearning: SwimlaneData;
}

export enum FocusArea {
  AldaRecommended = "ALDA_RECOMMENDED",
  Compliance = "COMPLIANCE",
  CoreInclusion = "CORE_INCLUSION",
  InclusiveLeadership = "INCLUSIVE_LEADERSHIP",
  AuthenticityAndMasking = "AUTHENTICITY_AND_MASKING",
  PsychologicalSafety = "PSYCHOLOGICAL_SAFETY",
  StrategicLeadership = "STRATEGIC_LEADERSHIP",
}

export interface SurveyPreference {
  days_until_launch: number;
}

export interface TrainingPreference {
  modules_per_quarter: number;
  focus_areas: FocusArea[];
}
export interface ActionPlanPreferences {
  survey_preference?: SurveyPreference;
  training_preference: TrainingPreference;
}

export enum ModuleSelectionState {
  Selected = "selected",
  Unselected = "unselected",
  BeingUsed = "being_used",
}

export interface TrainingModuleOption {
  trainingModule: TrainingModule;
  state: ModuleSelectionState;
  scheduledDate?: Date;
}

export interface ScheduledTrainingModule {
  training_module_id: string;
  start_date: string;
}
